import { NavLink } from "react-router-dom";
import { IonGrid, IonRow, IonCard } from "@ionic/react";
import { PageTitle } from "./PageTitle";

export const ImageArrayRender = (props) => {
  const { data, pageTitle, project } = props;
  const filteredReleases = data?.filter(
    (release) =>
      !["hits", "dj", "study", "top", "100"].some((keyword) =>
        release?.name?.toLowerCase().includes(keyword.toLowerCase())
      )
  );

  return (
    <IonGrid>
      <PageTitle pageTitle={pageTitle} />
      <IonRow className="inner-container">
        {filteredReleases &&
          filteredReleases.map((obj) => (
            <IonCard key={obj?.id} className="release-card transparent">
              <NavLink
                to={`/${project}/discography/${obj?.id}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="frame-box">
                  <img
                    alt="Release Cover"
                    src={obj?.images[1]?.url}
                    style={{
                      border: 0,
                      width: "18rem",
                      height: "18rem",
                    }}
                    loading="lazy"
                    seamless
                    draggable="false"
                  />
                </div>
                <div className="card-footer">
                  <IonRow>{obj?.name}</IonRow>
                  <IonRow>
                    {obj?.artists.map((artist, index) => (
                      <div key={artist.id}>
                        {artist.name}
                        {/* Add comma and space if not the last artist */}
                        {index !== obj.artists.length - 1 && ",\u00A0"}
                      </div>
                    ))}
                  </IonRow>
                </div>
              </NavLink>
            </IonCard>
          ))}
      </IonRow>
    </IonGrid>
  );
};
